import React from 'react';
/** icon-pen-m */
/** icon-pen */
/**
 * @typedef {Object} IconPenMProps
 * @property {string} [className] - Optional class name for the SVG element.
 */
export default ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        className={className}
    >
        <path
            d="M12.198.561c-.414.087-.71.217-1.078.473-.186.129-9.35 9.262-9.438 9.406-.027.044-.304 1.075-.615 2.292-.446 1.742-.563 2.237-.553 2.327.027.237.24.432.473.434.07 0 2.694-.659 4.464-1.122.097-.025.631-.55 4.678-4.593 2.512-2.511 4.639-4.652 4.725-4.758.788-.971.853-2.258.169-3.307a3.773 3.773 0 0 0-.736-.736c-.63-.411-1.391-.562-2.089-.416m1.029 1.001c.295.089.508.22.75.461.378.379.516.713.513 1.244-.001.27-.013.353-.072.533a1.696 1.696 0 0 1-.298.551l-.059.07-1.247-1.247-1.246-1.246.201-.135c.2-.134.439-.23.678-.274.179-.033.606-.009.78.043M9.333 9.16l-4.026 4.027L4.06 11.94l-1.247-1.247L6.84 6.667l4.027-4.027 1.246 1.247 1.247 1.246L9.333 9.16m-5.968 3.499c.525.524.946.96.935.97-.031.028-2.568.672-2.584.656-.024-.024.638-2.578.667-2.578.015 0 .457.428.982.952"
            fillRule="evenodd"
            fill="#1A2B49"
        />
    </svg>
);
